import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CheckboxField } from "@components/inputs/desktop";
import { LimitCategoryTypes } from "@data-types";
import { LIMITS_CONSTANTS } from "@services/account-settings/MyLimitsConstants";
import { getCurrentCulture } from "@utils";
import classNames from "classnames";

export default function LimitIncreaseTermsCheckbox(props: {
	amount: number | null | undefined;
	type: LimitCategoryTypes;
}) {
	const { getValues } = useFormContext();

	const isLimitIncreaseTermRequired =
		props.type === LimitCategoryTypes.GAMES ||
		Boolean(
			(props?.amount || 0) < getValues("amount") &&
				getValues("amount") > LIMITS_CONSTANTS.GAMES_MAX_DEPOSIT
		);

	const { t } = useTranslation("my-limits");

	const labelClassName = classNames(
		"input--check__label u-type--wgt--regular",
		{
			"is-required": isLimitIncreaseTermRequired,
		}
	);

	return (
		<>
			<div className="col col-sml-12 u-mar--top--xsml">
				<a
					className="u-anchor u-anchor--underline"
					href={`${WEBPACK_CDN_ROOT_URL}/web/legal/limit/limit-increase-consent_${getCurrentCulture()}.pdf`}
					target="_blank"
				>
					{t("LIMIT_INCREASE_CONSENT_DECLARATION_LINK")}
				</a>
			</div>

			<div className="col col-sml-12">
				<div className="form__field--acceptance u-mar--top--3">
					<CheckboxField
						id="consentGdpr"
						name="consentGdpr"
						required={isLimitIncreaseTermRequired}
						label="my-limits:LIMIT_INCREASE_CONSENT_GDPR"
						labelClassName={labelClassName}
					/>
				</div>

				<div className="form__field--acceptance u-mar--top--3">
					<CheckboxField
						id="consentGgl"
						name="consentGgl"
						required={isLimitIncreaseTermRequired}
						label="my-limits:LIMIT_INCREASE_CONSENT_GGL"
						labelClassName={labelClassName}
					/>
				</div>

				<div className="form__field--acceptance u-mar--top--3">
					<CheckboxField
						id="consentCreditCheck"
						name="consentCreditCheck"
						required={isLimitIncreaseTermRequired}
						label="my-limits:LIMIT_INCREASE_CONSENT_CREDIT_CHECK"
						labelClassName={labelClassName}
					/>
				</div>
			</div>
		</>
	);
}
